import { FC } from "react";
import { Box, Tooltip } from "@mui/material";
import { EventActivityStatus } from "../../../../../services/reports.service";

interface StatusCellProps {
	status: EventActivityStatus;
}

const STATUS_META: Record<
	EventActivityStatus,
	{ symbol: string; color: string; label: string }
> = {
	SUBMITTED: { symbol: "✓", color: "#1D9E75", label: "Submitted" },
	MISSED: { symbol: "✗", color: "#D85A30", label: "Missed" },
	PENDING: { symbol: "–", color: "#9E9E9E", label: "Pending" },
};

const StatusCell: FC<StatusCellProps> = ({ status }) => {
	const meta = STATUS_META[status];
	return (
		<Tooltip title={meta.label} arrow>
			<Box
				role="img"
				aria-label={meta.label}
				sx={{
					display: "inline-flex",
					alignItems: "center",
					justifyContent: "center",
					width: 24,
					height: 24,
					fontWeight: 700,
					fontSize: 16,
					color: meta.color,
				}}
			>
				{meta.symbol}
			</Box>
		</Tooltip>
	);
};

export default StatusCell;
